import { getOpxHostAppDetailStore } from './store/OpxHostAppDetail';

/**
 * Returns the device region and culture as set on the OPX host-app
 * @returns
 */
export const getOpxHostDeviceInfo = () => {
    const { deviceRegion, deviceCulture } = getOpxHostAppDetailStore();

    return { deviceRegion, deviceCulture };
};
